import { render, staticRenderFns } from "./ResearchIdExcelUpload.vue?vue&type=template&id=daa23c52&"
import script from "./ResearchIdExcelUpload.vue?vue&type=script&lang=ts&"
export * from "./ResearchIdExcelUpload.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports